import { Grid, Box } from "@mui/material";
import StatCard from "../common/StatCard";

export default function SummaryCards({ bigNumbers, clearNow, items = [] }) {
  
  return (
    <Grid
      container
      spacing={{ xs: 1.5, sm: 2, md: 2.5 }}
      sx={{ mb: { xs: 2, sm: 3 } }}
    >
      {items.map((item) => (
        <Grid
          key={item.title}
          size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}
        >
          <Box sx={{ height: "100%" }}>
            <StatCard {...item} />
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
